import { BankTransaction, MoneyDirection } from '../types';

export function resolveMoneyDirection(bankTransaction: Pick<BankTransaction, 'amount'>): MoneyDirection {
  return bankTransaction.amount > 0 ? 'IN' : 'OUT';
}
